export default __webpack_public_path__ + "static/misc3-ebc1bf164cded6219573fc2b6a8ccd4f.jpg";